const pendingDepositLoanRoutes = [
	{
		name: "pendingDepositLoanHome",
		path: "",
		component: () => import("./ListPendingDepositLoan.vue"),
		meta: {
			auth: true,
			title: "Pending Items Listing",
			breadcrumb: "Pending Items Listing",
			permission: ["view makerchecker"],
		},
	},

	{
		path: ":id",
		name: "showPendingDepositLoan",
		component: () => import("./ShowPendingDepositLoan.vue"),
		meta: {
			auth: true,
			title: "Showing Pending Item",
			breadcrumb: "Showing Pending Item",
			permission: ["view makerchecker"],
		},
	},
];

export default pendingDepositLoanRoutes;
